export const GET_RECENTLY_OPENED = 'GET_RECENTLY_OPENED'
export const GET_RECENTLY_OPENED_SUCCESS = 'GET_RECENTLY_OPENED_SUCCESS'
export const GET_RECENTLY_OPENED_FAILED = 'GET_RECENTLY_OPENED_FAILED'

export const PUT_RECENTLY_OPENED = 'PUT_RECENTLY_OPENED'
export const PUT_RECENTLY_OPENED_SUCCESS = 'PUT_RECENTLY_OPENED_SUCCESS'
export const PUT_RECENTLY_OPENED_FAILED = 'PUT_RECENTLY_OPENED_FAILED'

export const GET_RECENTLY_OPENED_ENTITIES = 'GET_RECENTLY_OPENED_ENTITIES'
export const GET_RECENTLY_OPENED_ENTITIES_FAILED = 'GET_RECENTLY_OPENED_ENTITIES_FAILED'
export const GET_RECENTLY_OPENED_ENTITIES_SUCCESS = 'GET_RECENTLY_OPENED_ENTITIES_SUCCESS'
